<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500;600;700;800;900&display=swap");

#app {
  font-family: "Orbitron", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,
body {
  width: 100%;
  height: 100%;
  background: black !important;
  overflow-x: hidden !important;
  font-family: "Orbitron", sans-serif !important;
}

body {
  position: fixed !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue